import { render, staticRenderFns } from "./UpdateModele.vue?vue&type=template&id=471f535e&"
import script from "./UpdateModele.vue?vue&type=script&lang=js&"
export * from "./UpdateModele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports